import styled, { css } from 'styled-components';

export const SideDrawerDiv = styled.div<{
  isDrawerOpen: boolean;
}>`
  position: fixed;
  width: 360px;
  max-width: 70%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 200;
  color: white;
  background-color: #454ade;
  box-sizing: border-box;
  transition: transform 0.3s;
  ${(props) =>
    !props.isDrawerOpen &&
    css`
      transform: translateX(-100%);
    `}
`;

export const UserInfo = styled.div`
  position: absolute;
  width: 90%;
  height: 139px;
  left: 7%;
  top: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const UserImage = styled.div`
  width: 48px;
  height: 48px;
  display:flex;
  flex-direction:row;
  justify-content:center;
  align-items:center;
  color: #454ade;
  font-family: Nunito;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 160%;
  background-color: #FFFFFF;
  border-radius: 16px;
`;

export const UserName = styled.div`
  position: static;
  margin-top: 12px;
  display: flex;
  font-family: Nunito;
  font-style: normal;
  order: 1;
  font-weight: 600;
  font-size: 18px;
  line-height: 150%;
  color: #ffffff;
`;

export const UserDetails = styled.div`
  position: static;
  font-family: Nunito;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 160%;
  color: #c5c6c9;
  display: flex;
`;

export const UserPhone = styled(UserDetails)`
  margin-top: 8px;
  order: 2;
`;

export const UserMail = styled(UserDetails)`
  width:100%;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  order: 3;
`;

export const SideDrawerContentDiv = styled.div`
  position: absolute;
  height: 224px;
  width:100%;
  top: 257px;
  display: flex;
  flex-direction: column;
  justify-content:flex-start;
  align-items: center;
`;

export const SideDrawerContent = styled.div`
  position: static;
  width:100%;
  display: flex;
  flex-direction: column;
  justify-content:flex-end;
  font-weight: 300;
  z-index:0;
`;

export const ContentText = styled.span<{height:number}>`
  position:static;
  text-overflow: ellipsis;
  height:${props=>props.height}px;
  width:93%;
  font-family: Nunito;
  font-style: normal;
  font-weight: inherit;
  font-size: 14px;
  line-height: 140%;
  padding: 0;
  margin-left: 7%;
  color: #ffffff;
  display: flex;
  margin-top:12px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index:300;
`;

export const ContentLine = styled.div`
  position: static;
  width: 100%;
  height: 1px;
  margin-top:12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1px;
`;

export const VersionDiv = styled.div`
  position: absolute;
  left: 6.67%;
  bottom: 3.75%;
  font-family: Nunito;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 160%;
  letter-spacing: 0.015em;
  color: #c5c6c9;
`;
export const WhiteChevron = styled.img`
width: 48px;
 height: 48px; 
 margin-right:-8px;
`;